






















































































































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Mutation, State} from 'vuex-class'
import Department from '@/modules/reservation/model/Department'
import ImageSelect from '@/components/ImageSelect.vue'
import {Colors, notify} from '@/modules/core/notification'
import LoadingScreen from '@/modules/core/LoadingScreen'
import {Watch} from 'vue-property-decorator'
import {Route} from 'vue-router'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import DepartmentTypeSelect from '@/modules/reservation/components/DepartmentTypeSelect.vue'
import DepartmentType from '@/modules/reservation/model/DepartmenType'
import Loader from '@/components/Loader.vue';

/**
 * Detalle de un componente
 *
 * Muestra al usuario una pantalla para visualizar y editar los detalles de un
 * departamento
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        Loader,
        ImageSelect,
        DepartmentTypeSelect,
    },
})
export default class DepartmentDetail extends Vue {
    public $refs: KeyValuePair

    @State(state => state.reservation.departmentDetail)
    public show: boolean

    @State(state => state.reservation.departmentTypes)
    public departmentTypes: Department[]

    @State(state => state.reservation.currentDepartment)
    public department: Department

    @Mutation('reservation/TOGGLE_DEPARTMENT_DETAIL')
    public toggleDetail: (toggle: boolean) => void

    public loading = true
    public saving = false
    public confirm = false

    public get isNew (): boolean {
        return !this.department.id
    }

    /**
     * Reglas para la validación del formulario
     */
    public rules = {
        name: [
            (v: any) => !_.isEmpty(v) || 'El nombre no puede estar vacío',
        ],
        capacity: [
            (v: any) => {
                const number = parseInt(v, 10)
                switch (true) {
                    case isNaN(number):
                        return 'Capacidad debe ser un valor numérico'
                    case number < 0:
                        return 'La capacidad no puede ser negativa'
                    default:
                        return true
                }
            },
        ],
        type: [
            (v: DepartmentType | null) => {
                if (!v || !v.id) {
                    return 'El tipo de departamento no puede estar vacío'
                }

                return true
            },
        ],
    }

    public updateField (field: string, value: any) {
        this.$store.commit('reservation/UPDATE_CURRENT_DEPARTMENT_FIELD', {field, value})
    }

    public get price () {
        return this.department.price.toString()
    }

    public set price (price: string) {
        this.updateField('price', parseFloat(price))
    }

    public get capacity () {
        return this.department.capacity.toString()
    }

    public set capacity (capacity: string) {
        this.updateField('capacity', parseInt(capacity, 10))
    }

    /**
     * Guarda el departamento
     */
    public async save () {
        if (!this.$refs.form.validate()) {
            notify('Comprueba la información', Colors.Warning, {
                notShowInCenter: true,
            })

            this.saving = false
            this.confirm = false

            return
        }

        this.saving = true
        try {
            await this.$store.dispatch('reservation/saveDepartment')
        } catch (e) {
            notify(e.message, Colors.Error)
        }

        this.saving = false
        this.confirm = false
    }

    @Watch('$route')
    public async onRouteChange (route: Route) {
        await this.loadDepartment(route)
    }


    public async loadDepartment (route: Route) {
        this.loading = true
        LoadingScreen.show('Cargando departamento')
        let id: string | number = this.$route.params['id']

        // El usuario ha solicitado comenzar a crear un nuevo departamento
        if (id === 'nuevo') {
            await this.$store.dispatch('reservation/loadNewDepartment')
            LoadingScreen.hide()
            this.loading = false

            return
        }

        id = parseInt(id, 10)
        if (!id || isNaN(id)) {
            notify('El id de departamento no es válido', Colors.Error)
            this.$router.push('dashboard')
            LoadingScreen.hide()
            this.loading = false

            return
        }

        try {
            await this.$store.dispatch('reservation/loadDepartment', id)
        } catch (e) {
            notify(e.message, Colors.Error)
            this.$router.push({name: 'reservations.department-list'})
        }

        LoadingScreen.hide()
        this.loading = false
    }

    public async created () {
        await this.loadDepartment(this.$route)
    }
}
